import React, { useState, useEffect } from 'react';
import { HomeURL } from '../services/Webservice';
import './Dashboard.css';

function Dashboard() {
    const [data, setData] = useState({
        Patient: 0,
        Technician: 0,
        bookings: 0,
        TodayAmount: 0,
        weeklyAmount: 0,
        monthlyAmount: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        /**
         * Technique: Component-Defined Endpoints
         * Instead of a large centralized API file, we construct the endpoint specifically needed for this component here.
         * This promotes modularity where the component "owns" its data requirements.
         * 
         * Pattern: Base URL (HomeURL from config) + Specific Route string
         */
        fetch(`${HomeURL}api/Admin/GET_Dashboard`)
            .then(response => response.json())
            .then(result => {
                // The API returns an array, we take the first item
                if (Array.isArray(result) && result.length > 0) {
                    setData(result[0]);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching dashboard data:', error);
                setLoading(false);
            });
    }, []);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0
        }).format(amount);
    };

    const stats = [
        { label: 'Total Patients', value: data.Patient, icon: '👤', colorClass: 'stat-blue' },
        //{ label: 'Technicians', value: data.Technician, icon: '🧑‍🔬', colorClass: 'stat-orange' },
        { label: 'Total Bookings', value: data.bookings, icon: '📅', colorClass: 'stat-green' },
        { label: 'Monthly Revenue', value: formatCurrency(data.monthlyAmount), icon: '💰', colorClass: 'stat-purple' },
    ];

    const currentDate = new Date().toLocaleDateString('en-IN', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    if (loading) {
        return (
            <div className="dashboard-container">
                <div className="loading-state">
                    <div className="loader"></div>
                    <p>Loading Dashboard...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-container">
            <header className="dashboard-header card">
                <div className="welcome-text">
                    <h1>Welcome back, Admin</h1>
                    <p>Credence Admin • Overview & Metrics</p>
                </div>
                <div className="date-display">
                    <span className="today">Today</span>
                    <span className="full-date">{currentDate}</span>
                </div>
            </header>

            <div className="stats-grid">
                {stats.map((stat) => (
                    <div key={stat.label} className={`stat-card card ${stat.colorClass}`}>
                        <div className="stat-info">
                            <span className="stat-label">{stat.label}</span>
                            <span className="stat-value">{stat.value}</span>
                        </div>
                        <div className="stat-icon-wrapper">
                            <span className="stat-icon">{stat.icon}</span>
                        </div>
                    </div>
                ))}
            </div>

            <div className="info-sections">
                <section className="info-card card">
                    <div className="info-header">
                        <h3>Today's Performance</h3>
                        <span className="timestamp">{new Date().toLocaleString()}</span>
                    </div>
                    <div className="info-content-grid">
                        <div className="mini-stat stat-blue">
                            <span className="mini-value">{formatCurrency(data.TodayAmount)}</span>
                            <span className="mini-label">Today's Revenue</span>
                        </div>
                    </div>
                </section>

                <section className="info-card card">
                    <div className="info-header">
                        <h3>Weekly Performance</h3>
                        <span className="timestamp">{new Date().toLocaleString()}</span>
                    </div>
                    <div className="info-content-grid">
                        <div className="mini-stat stat-green">
                            <span className="mini-value">{formatCurrency(data.weeklyAmount)}</span>
                            <span className="mini-label">Weekly Revenue</span>
                        </div>
                    </div>
                </section>

                <section className="info-card card">
                    <div className="info-header">
                        <h3>Monthly Performance</h3>
                        <span className="timestamp">{new Date().toLocaleString()}</span>
                    </div>
                    <div className="info-content-grid">
                        <div className="mini-stat stat-purple">
                            <span className="mini-value">{formatCurrency(data.monthlyAmount)}</span>
                            <span className="mini-label">Monthly Revenue</span>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Dashboard;
